import { render, staticRenderFns } from "./supplier-add-or-update.vue?vue&type=template&id=b2555830"
import script from "./supplier-add-or-update.vue?vue&type=script&lang=js"
export * from "./supplier-add-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports